import Vue from 'vue'
import Router from 'vue-router'

import Homepage from './pages/Homepage'
import PrivacyPolicies from './pages/PrivacyPolicies'

// import Download from './pages/Download'
import messages from './locales'

Vue.use(Router)

const routes = [
  {
    path: '',
    name: 'homepage',
    component: Homepage
  },
  {
    path: 'privacy-policies',
    name: 'privacy-policies',
    component: PrivacyPolicies
  },
  // {
  //   path: 'download',
  //   name: 'download',
  //   component: Download
  // },
  {
    path: '*',
    redirect: '/'
  }
]

let langRoutes = []

for (let i = 0; i < routes.length; i++)  {
  for (const locale of Object.keys(messages)) {
    const prefix = locale === 'en' ? '/' : '/' + locale + '/'
    let route = {...routes[i]}
    route.path = prefix + route.path
    route.name = locale + '/' + route.name
    route.meta = {
      ...routes[i].meta,
      locale: locale
    }

    langRoutes.push(route)
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes: langRoutes
})
